<template>
  <form ref="smsVerify" class="form--custom login__form" novalidate @submit.prevent="handleSmsVerify">
    <h2 class="login__title">{{ $t(`${namespace}.verification`) }}</h2>
    <p class="login__text">{{ $t(`${namespace}.smsVerifyTip`) }}</p>

    <label for="">{{ $t(`${namespace}.accessVerifyName`) }}</label>
    <v-text-field v-model="smsCode" name="smsCode" :placeholder="$t(`${namespace}.accessVerifyPlaceholder`)"
      :disabled="submittedStep2" v-validate.persist="{ required: true, smsCode: true }"
      :error-messages="errors.collect($t(`${namespace}.accessVerifyName`))"
      :data-vv-name="$t(`${namespace}.accessVerifyName`)" maxlength="6" required flat outline solo />

    <v-layout align-center justify-center row fill-height>
      <v-flex xs-6>
        <div class="resendWrap">
          <v-flex xs-6>
            <v-tooltip top max-width="220px">
              <span class="accent--text" v-html="$t(`${namespace}.notReceiveSms`)" slot="activator" />
              <div class="not_receive_tooltip">
                <span>{{ $t(`${namespace}.notReceiveSmsTooltip`) }}</span>
              </div>
            </v-tooltip>
          </v-flex>
          <v-btn color="warning--gradient" round block depressed large @click="reSendSms" :disabled="resendTimer > 0 || submittedStep2">
            {{ resendTimer > 0 ? `${resendTimer} ${$t(`${namespace}.seconds`)}` : $t(`${namespace}.resend`) }}
          </v-btn>
        </div>
        <div class="submitVerifyWrap">
          <v-btn type="submit" color="warning--gradient" :disabled="!enableSubmitSmsVerifyCode"
            :loading="submittedStep2" round block depressed large>
            {{ $t(`${namespace}.submitVerify`) }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { Omega, OmegaEventIds, OmegaBusiness, OmegaStatus } from 'common/omega'
import userService from '@/services/user'
export default {
  name: 'SmsVerifyForm',
  props: {
    ticket: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    submittedStep2: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.openTimer()
    this.$validator.extend('smsCode', {
      getMessage: field => this.$t(`${this.namespace}.validatorError`),
      validate: value => {
        function validateDigits (string) {
          var pattern = /^\d{6}$/
          return pattern.test(string)
        }
        return validateDigits(value)
      }
    })
  },
  computed: {
    enableSubmitSmsVerifyCode () {
      return this.smsCode && !this.submittedStep2
    }
  },
  data () {
    return {
      namespace: 'Views.LoginPage',
      smsCode: null,
      resendTimer: 60,
      timer: null
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),
    openTimer () {
      clearInterval(this.timer)
      this.resendTimer = 60
      this.timer = setInterval(() => {
        if (this.resendTimer > 0) this.resendTimer = this.resendTimer - 1
        else {
          clearInterval(this.timer)
        }
      }, 1000)
    },

    async reSendSms () {
      this.openTimer()
      try {
        await userService.resendCodeVerify(this.email, this.ticket)
      } catch (error) {
        const errorMsg = error && error.response && error.response.data && error.response.data.reasons
          ? error.response.data.reasons[0]
          : this.$t('Messages.genericError')
        this.errorAlert(errorMsg)
      }
    },

    async handleSmsVerify () {
      // 登录步骤二点击验证
      Omega.trackBusiness(
        OmegaEventIds.tech_b2bv3_login,
        {
          business: OmegaBusiness.login,
          type: 'step2',
          status: OmegaStatus.op,
          params: {
            type: 'sms'
          }
        }
      )
      const isValid = await this.$validator.validateAll()
      if (!isValid) return
      const { email, smsCode } = this
      this.$emit('changeSubmittedStep2', true)
      try {
        const user = await userService.codeVerify(email, smsCode, this.ticket)
        this.$emit('handleLoggedUser', user)
      } catch (err) {
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_login,
          {
            business: OmegaBusiness.login,
            type: 'step2',
            status: OmegaStatus.error,
            msg: err?.message,
            params: {
              type: 'sms'
            }
          }
        )
        this.$emit('handleError', err)
      }
    }
  },
  mounted () {
    try {
      if (this.$refs.smsVerify) {
        // 登录步骤二成功渲染
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_login,
          {
            business: OmegaBusiness.login,
            type: 'step2',
            status: OmegaStatus.sw,
            params: {
              type: 'sms'
            }
          }
        )
      } else {
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_login,
          {
            business: OmegaBusiness.login,
            type: 'step2',
            status: OmegaStatus.swError,
            params: {
              type: 'sms'
            }
          }
        )
      }
    } catch (e) {
      console.log('omega上报错误')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-tooltip__content {

  // background: #ffffff !important;
  .not_receive_tooltip {
    color: #FFFFFF;
    font-size: 14px;
  }
}
</style>
